export default __webpack_public_path__ + "static/media/sv.45dcf514.svg";